export default __webpack_public_path__ + "static/media/attackontitan.ebdab479.png";